import { render, staticRenderFns } from "./AddClientForm.vue?vue&type=template&id=f390ea92&"
import script from "./AddClientForm.vue?vue&type=script&lang=js&"
export * from "./AddClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports